<template>
  <el-container class="pid-dashboard" key="monitor">
    <el-aside width="200px" v-if="isCollapse">
      <div class="menu-title custom-title">
        <span class="prefix-icon"></span>
        <span>{{ '任务列表' | translateTo }}</span>
      </div>
      <Menu @select="selectHandler" />
    </el-aside>
    <el-main>
      <div class="main-header">
        <div class="main-title custom-title">
          <span class="prefix-icon"></span>
          <span>{{ '设备分布' | translateTo }}</span>
        </div>
        <div class="toggle-icon" @click="changeCollapse">
          <em :class="!isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></em>
        </div>
      </div>
      <DeviceMap ref="deviceMap" :map-config="mapConfig">
        <div class="control-wrap" v-if="taskId">
          <div
            class="iconfont icon-setting"
            v-if="authMenu['01020801']"
            @click="visible = true"
          ></div>
          <GradientBar v-if="mapConfig" :max="max" :gradient="mapConfig.gradient" />
        </div>
      </DeviceMap>
      <MapSetting
        ref="mapSetting"
        v-if="taskId && visible"
        :config="mapConfig"
        @confirm="confirm"
        @close="visible = false"
      />
    </el-main>
  </el-container>
</template>

<script>
import { mapState } from 'vuex';

import Menu from './menu.vue';
import { getDeviceMap, getDevicemapParam, renewDeviceMap, saveDevicemapParam } from '@/api/task';
import DeviceMap from './deviceMap.vue';
import MapSetting from './mapSetting.vue';
import GradientBar from '@/components/gradientBar';

import { isArray, isEmpty, isObject } from '@/utils/is';
import { propFilter } from '@/utils/utils';
// import { convexClosure, getRectByPoints, polygonScale } from '@/utils/algorithm';
import { stopDeviceMap } from '@/api/devices';
import { subscribe } from '@/utils/mqtt';

export default {
  components: {
    DeviceMap,
    Menu,
    MapSetting,
    GradientBar
  },
  sockets: {
    '/socket/devicemap/detail'(res) {
      if (!this.deviceMap || !this.deviceData) return;
      const deviceData = this.patchDevice(res.deviceData);
      this.deviceMap.upBasicData({ ...res, deviceData, max: res.max || 10 });
      this.deviceMap.updateCallback(() => {
        this.max = res.max;
      });
    }
  },
  data() {
    return {
      isCollapse: true,
      data: {},
      initPoint: {},
      rawMapConfig: null,
      mapConfig: null,
      taskId: '',
      visible: false,
      max: 0,
      deviceMap: null,
      deviceData: null,
      renewTimer: null
    };
  },
  computed: {
    ...mapState('admin', ['authMenu'])
  },
  provide() {
    return {
      getData: () => this.data
    };
  },
  methods: {
    patchDevice(data) {
      const now = Date.now();

      let deviceMap = data.reduce((map, e) => {
        map[e.sn] = {
          name: e.showName,
          updateTime: now,
          state: e.state,
          coordinate: [e.longitude, e.latitude],
          sn: e.sn,
          runstate: e.runstate,
          radius: e.radius || 0,
          data: +e.pidValue || 0
        };
        return map;
      }, {});
      deviceMap = Object.assign(this.deviceData, deviceMap);
      return Object.values(deviceMap);
    },
    subscribe() {
      // this.$socket.emit('/socket/devicemap/detail', id);
      subscribe('{prefix}/{userId}/devicemap/detail/');
    },
    unsubscribe() {
      stopDeviceMap();
      // this.$socket.emit('/socket/unsubscribe/devicemap/detail', id);
    },
    async confirm(data) {
      const { deviceMapParamItems } = this.rawMapConfig;
      data.gradient = data.gradients.reduce((map, e) => {
        map[e.value] = e.color;
        return map;
      }, {});
      data = propFilter(data, [
        'deviceBorderLength',
        'borderLength',
        'wInterval',
        'size',
        'gradient'
      ]);
      const items = deviceMapParamItems.filter(e => {
        if (data.hasOwnProperty(e.itemCode)) {
          if (e.itemCode === 'gradient') {
            e.value = JSON.stringify(data[e.itemCode]);
          } else {
            e.value = data[e.itemCode];
          }
          return true;
        }
      });
      const params = {
        taskId: this.taskId,
        deviceMapParamItems: items
      };
      await saveDevicemapParam(params);
      this.$refs.mapSetting.hideLoading();
      this.$message.success('修改成功');
      this.setMapConfig(params);
      this.visible = false;
    },
    setMapConfig(config) {
      if (!isObject(config)) return;
      this.rawMapConfig = config;
      const { deviceMapParamItems } = config;

      if (!isArray(deviceMapParamItems)) return;
      const temp = {};
      deviceMapParamItems.forEach(item => {
        if (item.itemCode === 'gradient') {
          temp[item.itemCode] = JSON.parse(item.value);
        } else if (item.itemCode === 'max') {
          temp[item.itemCode] = this.max || +item.value;
        } else {
          temp[item.itemCode] = item.value;
        }
      });
      this.mapConfig = temp;
    },
    async getDevicemapParam(taskId) {
      const { data } = (await getDevicemapParam(taskId)) || {};
      this.setMapConfig(data);
    },
    startRenew(id) {
      if (this.renewTimer) clearInterval(this.renewTimer);

      if (isEmpty(id)) return;

      renewDeviceMap(id);

      this.renewTimer = setInterval(() => {
        renewDeviceMap(id);
      }, 20000);
    },
    stopRenew() {
      if (this.renewTimer) clearInterval(this.renewTimer);
    },
    selectHandler(taskId) {
      const $map = this.$refs.deviceMap;
      if (this.taskId && this.taskId !== taskId) {
        this.unsubscribe(this.taskId);
        $map.reset();
      }
      this.subscribe(taskId);
      this.taskId = taskId;
      this.getDevicemapParam(taskId);

      this.startRenew(taskId);

      getDeviceMap(taskId).then(res => {
        const { data } = res;
        this.data = data;
        const coordinates = [];
        const deviceDataMap = data.devices.reduce((map, e) => {
          coordinates.push([e.longitude, e.latitude]);
          map[e.sn] = {
            updateTime: Date.now(),
            state: e.state,
            coordinate: [e.longitude, e.latitude],
            sn: e.sn,
            runstate: e.runstate,
            data: 0
          };
          return map;
        }, {});
        const devices = Object.values(deviceDataMap);

        $map.sns = devices.map(e => e.sn);
        this.deviceData = deviceDataMap;
        $map.upBasicData({ deviceData: devices, max: 10 });
        $map.animation(data.centerPosition);

        if (coordinates.length >= 3) {
          // const points = getRectByPoints(coordinates, 0.00061);

          const points = [
            [116.570383, 40.086248],
            [116.57085, 40.09036],
            [116.57484, 40.090098],
            [116.5743694, 40.085983]
          ];

          // let points = convexClosure(coordinates);
          // points = polygonScale(points, 0.00081);

          $map.drawPolygon(points.concat([points[0]]));
        }
      });
    },
    changeCollapse() {
      this.isCollapse = !this.isCollapse;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.deviceMap = this.$refs.deviceMap;
    });
  },
  beforeDestroy() {
    this.stopRenew();
    this.unsubscribe();
  }
};
</script>

<style lang="scss">
.pid-dashboard {
  height: 100%;
  .menu-title {
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    color: #0ef;
  }
  .prefix-icon {
    display: inline-block;
    background-color: #f5ff54;
    height: 10px;
    width: 4px;
    margin-right: 5px;
  }
  .custom-title {
    font-size: 20px;
    font-weight: bold;
  }
  .el-main {
    height: 100%;
    overflow: hidden;
    padding-left: 20px;

    .main-header {
      display: flex;
      align-items: center;
      color: #0ef;

      .toggle-icon {
        width: 60px;
        text-align: center;
        font-size: 26px;
        cursor: pointer;
      }
    }

    .control-wrap {
      position: absolute;
      z-index: 10;
      right: 30px;
      top: 30px;
      text-align: right;

      .icon-setting {
        font-size: 22px;
        color: #00eeff;
        margin-bottom: 10px;
        cursor: pointer;
      }

      .block {
        display: flex;
        align-items: center;
        width: 140px;
        .label {
          display: inline-block;
          color: #49c7c3;
          min-width: 48px;
          text-align: right;
        }
        .radius-slider {
          flex: 1;
        }
      }
    }
  }
}
</style>
